import React, { useState } from 'react';
import './App.css';
import Dashboard from './components/Dashboard';
import Market from './components/Market';
import News from './components/News';
import { Sidebar } from './components/Sidebar';

function App() {
  
  const [activeTab, setActiveTab] = useState("Dashboard");

  return (
    <div className="App">
      <div className='flex bg-color2 dark:bg-color1'>
        <Sidebar activeTab={activeTab} setActiveTab={setActiveTab}/>
        <div className='w-full'>
          {activeTab === "Dashboard" && <Dashboard />}
          {activeTab === "Market" && <Market />}
          {activeTab === "News" && <News />}
        </div>
      </div>
      <footer>
        <p>
          MarketMint - Project by <a href='https://elenazen.it/' className='underline'>Elena Zen</a>
        </p>
      </footer>
    </div>
  );
}

export default App;
